import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useEffect, useState } from 'react';
import RichTextViewer from 'components/rich-text-viewer/rich-text-viewer';
const QuestionMultipleChoiceOption = ({ questionId, answer, onlyOnce, localAnswers, toggleCheck }) => {
    const [height, setHeight] = useState();
    const [style, setStyle] = useState();
    useEffect(() => {
        if (!height) {
            return;
        }
        setStyle({ height: height + 'px' });
    }, [height]);
    return (_jsxs("fieldset", Object.assign({ className: "fieldset--radio fieldset--radio--with-image", style: style }, { children: [_jsx("input", { type: onlyOnce ? 'radio' : 'checkbox', name: "answers", id: `${answer.id}`, checked: localAnswers.includes(answer.id) ? true : false, onChange: () => toggleCheck(answer.id) }, void 0), _jsx("div", Object.assign({ className: "pl-5 option--image-container" }, { children: _jsx(RichTextViewer, { id: `question-${questionId}-answer-${answer.id}`, content: answer.title, getHeight: setHeight }, void 0) }), void 0)] }), answer.id));
};
export default QuestionMultipleChoiceOption;
